export const BUSINESS = {
  name: "Apex Home Renovation LLC",
  tagline: "Transforming Houses Into Homes, One Vision at a Time.",
  motto: "Your Vision. Our Expertise. Your Home.",
  established: "2023",
  phoneActive: "(253) 921-9781",
  phoneActiveHref: "tel:+12539219781",
  phoneAdmin: "(206) 687-2329",
  phoneAdminHref: "tel:+12066872329",
  email: "Apexhomerenovationco@gmail.com",
};

export const NAV_LINKS = [
  { label: "HOME", href: "#home" },
  { label: "ABOUT US", href: "#about" },
  { label: "SERVICES", href: "#services" },
  { label: "OUR PROJECTS", href: "#projects" },
  { label: "SERVICE AREAS", href: "#areas" },
  { label: "REQUEST AN ESTIMATE", href: "#estimate" },
  { label: "CONTACT", href: "#contact" },
];

export const SERVICES = [
  {
    id: "flooring",
    title: "Flooring Installation & Replacement",
    desc: "Hardwood, laminate, vinyl and tile flooring installed with precision and care.",
    img: "https://images.pexels.com/photos/1388944/floor-flooring-hand-man-1388944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "painting",
    title: "Interior & Exterior Painting",
    desc: "Clean lines, lasting finishes and curb appeal that transforms your home.",
    img: "https://images.pexels.com/photos/6474491/pexels-photo-6474491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "kitchen-bath",
    title: "Kitchen & Bathroom Renovations",
    desc: "Beautiful, functional kitchens and baths built around how your family lives.",
    img: "https://images.pexels.com/photos/39383577/pexels-photo-39383577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "drywall",
    title: "Drywall Installation & Repairs",
    desc: "From patches to full installs — smooth walls and ceilings, ready for paint.",
    img: "https://images.pexels.com/photos/6474129/pexels-photo-6474129.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "decks",
    title: "Deck Construction & Repairs",
    desc: "Outdoor living spaces built strong, finished beautifully, made to last.",
    img: "https://images.pexels.com/photos/7587879/pexels-photo-7587879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "repairs",
    title: "General Home Repairs & Improvements",
    desc: "Dependable repairs and improvements, handled right the first time.",
    img: "https://images.pexels.com/photos/36035072/pexels-photo-36035072.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "restoration",
    title: "Refurbishment & Restoration",
    desc: "Thoughtful restoration that brings worn spaces back to life.",
    img: "https://images.pexels.com/photos/35564974/pexels-photo-35564974.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "remodeling",
    title: "Residential Remodeling",
    desc: "Whole-room and whole-home remodeling, from first vision to final walkthrough.",
    img: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MjEyODk5NHww&ixlib=rb-4.1.0&q=85",
  },
];

export const AREAS = [
  "Petersburg",
  "Hopewell",
  "Blackstone",
  "Mineral",
  "Colonial Heights",
  "Crewe",
  "Richmond",
  "Chesterfield County — All Areas",
];

export const PROJECTS = [
  {
    id: "deck-porch",
    title: "Deck & Porch Revival",
    location: "Central Virginia",
    desc: "A weathered porch and deck rebuilt and refinished — new railings, fresh surfaces and a ceiling fan for outdoor comfort. From vision to reality.",
    services: ["Deck Construction & Repairs", "Painting", "Outdoor Living"],
    img: "/assets/project-deck.jpeg",
  },
  {
    id: "exterior-refresh",
    title: "Full Exterior Refresh",
    location: "Central Virginia",
    desc: "Complete exterior renovation including professional painting, gutter cleaning and a full front & back yard clean up — a refreshed, welcoming home.",
    services: ["Exterior Painting", "Gutter Cleaning", "Curb Appeal Upgrade"],
    img: "/assets/project-exterior.jpeg",
  },
  {
    id: "interior-renewal",
    title: "Interior Repairs & Painting",
    location: "Central Virginia",
    desc: "Ceiling repair, drywall work and a full interior repaint. Same space — a completely new feel. Clean, fresh, modern.",
    services: ["Drywall Repair", "Interior Painting"],
    img: "/assets/project-interior.jpeg",
  },
];

export const PAYMENT_METHODS = [
  { id: "zelle", name: "Zelle", note: "Bank-to-bank transfer", detail: "Xandriaakiwowiggins@gmail.com", detailLabel: "Recipient: Xandria Aguon-Omar", copy: "Xandriaakiwowiggins@gmail.com" },
  { id: "cashapp", name: "Cash App", note: "Mobile payment", detail: "$Isaiahthepianist", detail2: "or $XandriaW11", copy: "$Isaiahthepianist", copy2: "$XandriaW11" },
  { id: "applepay", name: "Apple Pay", note: "Tap to pay", detail: "Call us to arrange Apple Pay" },
  { id: "square", name: "Square", note: "Card payment link", detail: "Request an approved pay link and we'll send it to you" },
  { id: "venmo", name: "Venmo", note: "Mobile payment", detail: "@XannyW11", copy: "@XannyW11" },
  { id: "cash", name: "Cash", note: "In person", detail: "Accepted in person" },
  { id: "check", name: "Check", note: "Final payments only", detail: "Accepted for final payments only" },
];

export const TIME_SLOTS = [
  "8:00 AM – 10:00 AM",
  "10:00 AM – 12:00 PM",
  "12:00 PM – 2:00 PM",
  "2:00 PM – 4:00 PM",
  "4:00 PM – 6:00 PM",
];

export const CONSULT_TYPES = [
  "On-Site Consultation",
  "Phone Consultation",
  "Virtual Walkthrough",
];

export const BUDGET_RANGES = [
  "Under $2,500",
  "$2,500 – $5,000",
  "$5,000 – $10,000",
  "$10,000 – $25,000",
  "$25,000+",
  "Not sure yet",
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3VzZSUyMGludGVyaW9yJTIwcmVtb2RlbHxlbnwwfHx8fDE3OTIxMjg5OTR8MA&ixlib=rb-4.1.0&q=85";
